module.exports = __webpack_public_path__ + "static/media/negro.66ea8bf6.png";